export default __webpack_public_path__ + "images/models/592d8e4efe9aa0745425977c6826fe1d.usdz";